var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { AppWidth, DocWidth, P, Flex, Link } from '@tpr/core';
import styles from './footer.module.scss';
export var Footer = function (_a) {
    var logoUrl = _a.logoUrl, _b = _a.logoAlt, logoAlt = _b === void 0 ? 'The Pensions Regulator logo' : _b, _c = _a.copyright, copyright = _c === void 0 ? '© 2020 The Pensions Regulator' : _c, links = _a.links;
    return (React.createElement(DocWidth, { className: styles.wrapper },
        React.createElement(AppWidth, null,
            React.createElement(Flex, { cfg: { flexDirection: 'column' } },
                React.createElement(Flex, { cfg: { justifyContent: 'flex-start', p: 6, alignItems: 'center' } },
                    React.createElement("img", { src: logoUrl, alt: logoAlt, width: "180", height: "75" })),
                React.createElement(Flex, { cfg: { justifyContent: 'space-between', mt: 3, px: 6 }, className: styles.footerText },
                    React.createElement(Flex, null, links.map(function (_a, key) {
                        var url = _a.url, title = _a.title, linkProps = __rest(_a, ["url", "title"]);
                        return (React.createElement(Link, __assign({ key: key, href: url, cfg: { mr: 3, color: 'neutral.a2' } }, linkProps), title));
                    })),
                    React.createElement(P, { cfg: { fontSize: 1, color: 'neutral.a2', my: 1 } }, copyright))))));
};
//# sourceMappingURL=footer.js.map